import {
  InputHTMLAttributes,
  TextareaHTMLAttributes,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { getCurrentUrlFormat } from './utils';

type ConversionState = 'idle' | 'processing' | 'finished';

interface IUseConversionProps {
  inputAttributes?:
  | InputHTMLAttributes<HTMLInputElement>
  | TextareaHTMLAttributes<HTMLTextAreaElement>;
  value?: string | null;
  linkConversionAI?: boolean;
  notField?: boolean;
}

type TUseConversion = (props: IUseConversionProps) => {
  setFocused: React.Dispatch<React.SetStateAction<boolean>>;
  conversionActionTooltipShow: boolean;
  setConversionActionTooltipShow: React.Dispatch<React.SetStateAction<boolean>>;
  processingConversion: () => void;
  showConversionIcon?: boolean;
  conversionState: ConversionState;
};

export const useConversion: TUseConversion = ({
  inputAttributes,
  value,
  linkConversionAI,
  notField,
}) => {
  const [focused, setFocused] = useState(false);
  const [convertedValue, setConvetredValue] = useState<string | null>(null);
  const hasValue = useMemo(
    () => !!value || !!inputAttributes?.value,
    [value, inputAttributes],
  );
  const [conversionActionTooltipShow, setConversionActionTooltipShow] =
    useState(false);
  const [conversionState, setConversionState] =
    useState<ConversionState>('idle');

  const convertLinkObject = {
    target: {
      value: getCurrentUrlFormat(String(inputAttributes?.name), String(inputAttributes?.value)) || '',
      name: inputAttributes?.name,
      type: 'text',
    },
  } as unknown as React.ChangeEvent<HTMLInputElement> &
    React.ChangeEvent<HTMLTextAreaElement>;

  const processingConversion = () => {
    setConversionState('processing');
    inputAttributes?.onChange?.(convertLinkObject);
    setConvetredValue(getCurrentUrlFormat(String(inputAttributes?.name), String(inputAttributes?.value)));
    setConversionState('finished');

    const timer = setTimeout(() => {
      setConversionState('idle');
    }, 3000);

    return () => clearTimeout(timer);
  };

  // показываем только во всех случаях, кроме конца процесса
  const conversionConditionForIcon = conversionState !== 'finished';

  // включено преобразование ссылки
  // включено редактирование
  // фокус на поле
  // значение есть
  const showConversionIcon =
    convertedValue !== String(inputAttributes?.value) &&
    linkConversionAI &&
    notField &&
    focused &&
    hasValue &&
    conversionConditionForIcon;

  // setConversionActionTooltipShow - отвечает только за то, какой тултип показывается
  // Нам не надо его менять в зависимости от значения
  // useEffect(() => {
  //   if (inputAttributes?.value === convertedValue) {
  //     setConversionActionTooltipShow(false);
  //   } else {
  //     setConversionActionTooltipShow(true);
  //   }
  // }, [inputAttributes?.value]);

  useEffect(
    () => () => {
      if (!linkConversionAI) {
        setConvetredValue('');
      }
    },
    [linkConversionAI],
  );

  return {
    setFocused,
    conversionActionTooltipShow,
    setConversionActionTooltipShow,
    processingConversion,
    showConversionIcon,
    conversionState,
  };
};
